// External Imports
import { useContext } from "react";

// Internal Imports
import { UtilityContext } from "../../context/util-context";

/** ========================================================================
 * * DetailList Component
 * This component renders a list of provided values.
 * ========================================================================== */

export default function DetailList({ label, values, link, onClick, loading }) {
  const { navigate } = useContext(UtilityContext);
  const clickHandler = (e) => {
    if (link) navigate(link, e);
    if (onClick) onClick();
  };
  if (loading)
    return (
      <div className="grid gap-2 p-1">
        <div className="w-1/3 h-4 rounded animate-pulse bg-stone-800"></div>
        <div className="h-6 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-700"></div>
      </div>
    );
  return (
    <div
      onClick={clickHandler}
      className="grid gap-2 p-1 text-sm rounded-lg clickable text-stone-400"
    >
      <p className="font-semibold text-stone-200">{label}:</p>
      {values.map((value, idx) => {
        if (typeof value === "string") return <p key={idx}>{value}</p>;
        if (typeof value === "object")
          return (
            <p key={idx} className={value.classes || "text-primary"}>{value.name}</p>
          );
      })}
    </div>
  );
}
